import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from './routes/Home/Container';
import About from './routes/About/Container';
import BusinessRegistration from './routes/BusinessRegistration/Container';
import Search from './routes/Search/Container';
import Login from './routes/Login/Container';
import SignUp from './routes/SignUp/Container';
import BusinessDetail from './routes/BusinessDetail/Container';
import PaymentResult from './routes/PaymentResult/Container';
import UserProfile from './routes/UserProfile/Container';
import AdminSupport from './routes/AdminSupport/Container';
import CancelBooking from './routes/CancelBooking';
import GlobalStyles from './components/CustomStyledComponents/Global';

const AppNavigator = () => {
    return (
        <Router>
            <GlobalStyles />
            <Switch>
                <Route path='/' exact component={Home} />
                <Route path='/home' exact component={Home} />
                <Route path='/about' component={About} />
                <Route path='/search' component={Search} />
                <Route path='/businessRegistration' component={BusinessRegistration} />
                <Route path='/login' component={Login} />
                <Route path='/signup' component={SignUp} />
                <Route path='/profile' component={UserProfile} />
                <Route path='/admin/support' component={AdminSupport} />
                <Route path='/cancelar/:bookingId' component={CancelBooking} />
                <Route path='/booking/payment-success' component={PaymentResult} />
                <Route path='/booking/payment-failure' component={PaymentResult} />
                <Route path='/booking/payment-pending' component={PaymentResult} />
                <Route path='/b/:businessName' component={BusinessDetail} />
            </Switch>
        </Router>
    );
};

export default AppNavigator;